let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("84O3i")).then(() => parcelRequire('iOkVk'));